import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class Test extends Component {
  static propTypes = {
    systemconfig: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="systemconfig-test">
        Page Content: systemconfig/Test
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    systemconfig: state.systemconfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Test);



// WEBPACK FOOTER //
// ./src/features/systemconfig/Test.js